import React, { Component, Fragment } from "react";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../utils/utils";

import Select from "../../Relatorio1/Select";
import Radio from "../../Relatorio1/Radio";

import relatorioMetasRealizadosService from "../../../../../services/relatorioMetasRealizadosService";
import TabelaFaculdade from "./TabelaFaculdade";

export default class TabelaMetaRealizado extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            realizados: {},
            acumulado: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes"
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado || prevState.mesSelecionado !== this.state.mesSelecionado) {
            await this.getDados();
        }
    }

    getDados = async () => {
        let { dados, realizados, acumulado } = await relatorioMetasRealizadosService.fetchDados(this.state.mesSelecionado, this.state.isAcumulado);
        this.setState({ dados, realizados, acumulado });
    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value })
    }

    calculaTotal = (dados, realizados, isNotTotalGeral=true) => {

        let valorRealizado = realizados && realizados[realizados && realizados.findIndex(v => v.unidade === utils.getUnidadeRealizado(dados.unidade))];

        let total = {
            matricula_regimental: 0,
            matricula_nao_regimental: 0,
            matricula_pago: 0,
            hora_regimental: 0,
            hora_nao_regimental: 0,
            hora_pago: 0,
            r_matricula_regimental: 0,
            r_matricula_nao_regimental: 0,
            r_matricula_pago: 0,
            r_hora_regimental: 0,
            r_hora_nao_regimental: 0,
            r_hora_pago: 0,
        }

        if (dados) {
            Object.keys(dados.modalidades).map((modalidade, i) => {
                if(isNotTotalGeral) {
                    if(modalidade.indexOf("Graduaç") > -1 || modalidade.indexOf("Extensão") > -1) return;
                }
                total["matricula_regimental"]     += dados.modalidades[modalidade]["matricula_regimental"]
                total["matricula_nao_regimental"] += dados.modalidades[modalidade]["matricula_nao_regimental"]
                total["matricula_pago"]           += dados.modalidades[modalidade]["matricula_pago"]
                total["hora_regimental"]          += dados.modalidades[modalidade]["hora_regimental"]
                total["hora_nao_regimental"]      += dados.modalidades[modalidade]["hora_nao_regimental"]
                total["hora_pago"]                += dados.modalidades[modalidade]["hora_pago"]
            });
        }

        if (valorRealizado) {
            Object.keys(valorRealizado.modalidades).map((modalidade, i) => {
                if(isNotTotalGeral) {
                    if(modalidade.indexOf("91 Pós") > -1 || modalidade.indexOf("41 Gra") > -1 || modalidade.indexOf("87 Cur") > -1) return;
                }
                total["r_matricula_regimental"]     += valorRealizado.modalidades[modalidade]["matricula_regimental"]
                total["r_matricula_nao_regimental"] += valorRealizado.modalidades[modalidade]["matricula_nao_regimental"]
                total["r_matricula_pago"]           += valorRealizado.modalidades[modalidade]["matricula_pago"]
                total["r_hora_regimental"]          += valorRealizado.modalidades[modalidade]["hora_regimental"]
                total["r_hora_nao_regimental"]      += valorRealizado.modalidades[modalidade]["hora_nao_regimental"]
                total["r_hora_pago"]                += valorRealizado.modalidades[modalidade]["hora_pago"]
            });
        }

        return total;

    }

    verificaSePossuiRealizado = (realizados, mesSelecionado) => {
        let realizadoMes = realizados[mesSelecionado];
        if(!realizadoMes) {
            let ultimoMesApurado = this.verificaUltimoMesApurado(realizados);
            realizadoMes = realizados[ultimoMesApurado]
        }
        return realizadoMes;
    }

    verificaUltimoMesApurado = (realizados) => {
        let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
        let mesesApurados = Object.keys(realizados);

        let ultimoMesApurado = mesesApurados.reduce((acc, atual) => {
            let index = meses.indexOf(atual);
            if(index >= acc) return index;
            else return acc
        }, -1)

        return meses[ultimoMesApurado];
    }

    render() {
        let { dados, mesSelecionado, realizados, isAcumulado, radioChecked, acumulado } = this.state;
        let totais;
        realizados = this.verificaSePossuiRealizado(realizados, mesSelecionado)

        if(isAcumulado) {
            dados = { ...acumulado }
        }
        
        let isExibeFiltro = !this.props.isExibeFiltro;

        return (
            <Fragment>
                
                {
                    isExibeFiltro
                    ?
                    <div className="card">
                        <div className="card-header">
                            Opções
                        </div>
                        <div className="card-body">
                            <Select selectMes={this.selectMes} />
                            <Radio onChange={this.onChange} radioChecked={radioChecked} />
                        </div>
                    </div>
                    :
                    null
                }

                <Tabs defaultActiveKey={"DR"}>

                    {dados[mesSelecionado] && dados[mesSelecionado].map((valor, i) => {

                        let sigla = utils.verificaSiglaUnidade2(valor.unidade);
                        let total = this.calculaTotal(valor, realizados);
                        let totalGeral = this.calculaTotal(valor, realizados, false);

                        return (
                            <Tab eventKey={sigla} title={sigla}>

                                <Fragment>
                                    <div className="table-responsive">
                                        <table border="1" className="table table-bordered table-hover table-sm table-striped text-center">
                                            <thead>
                                                <tr>
                                                    <th colSpan="19" className="text-center">{valor.unidade}</th>
                                                </tr>
                                                <tr>
                                                    <th rowSpan="4">Modalidades</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="9" className="text-center">Matrículas</th>
                                                    <th colSpan="9" className="text-center">Horas</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="4" className="text-center">Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                    <th colSpan="5" className="text-center">Realizado (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                    <th colSpan="4" className="text-center">Meta (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                    <th colSpan="5" className="text-center">Realizado (<span style={{ textTransform: "uppercase" }}>{mesSelecionado}</span>) </th>
                                                </tr>
                                                <tr>
                                                    {/*<th>Modalidades</th>*/}
                                                    <th>Matrículas Regimental</th>
                                                    <th>Matrículas Não-Regimental</th>
                                                    <th>Matrículas Pagas</th>
                                                    <th>Total</th>
                                                    <th>Matrículas Regimental</th>
                                                    <th>Matrículas Não-Regimental</th>
                                                    <th>Matrículas Pagas</th>
                                                    <th>Total</th>
                                                    <th>%</th>
                                                    <th>Hora Regimental</th>
                                                    <th>Hora Não-Regimental</th>
                                                    <th>Hora Pagas</th>
                                                    <th>Total</th>
                                                    <th>Hora Regimental</th>
                                                    <th>Hora Não-Regimental</th>
                                                    <th>Hora Pagas</th>
                                                    <th>Total</th>
                                                    <th>%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {utils.retornaArrayModalidades().map((modal, j) => {
                                                    
                                                    if(modal.search("91 Pós") > -1 || modal.search("41 Gra") > -1 || modal.search("87 Cur") > -1) return;

                                                    let valorRealizado, modalidade, valorMeta;
                                                    modalidade=modal;

                                                    try {
                                                        valorRealizado = realizados && realizados[realizados && realizados.findIndex(v => v.unidade === utils.getUnidadeRealizado(valor.unidade))];
                                                        valorRealizado = utils.verificaValorModalidade(valorRealizado, modal);
                                                        modal = utils.getModalidades(modal, true);

                                                        valorMeta = valor.modalidades[modal];
                                                        if(valorMeta === undefined) {
                                                            valorMeta = {
                                                                hora_nao_regimental: 0,
                                                                hora_pago: 0,
                                                                hora_regimental: 0,
                                                                matricula_nao_regimental: 0,
                                                                matricula_pago: 0,
                                                                matricula_regimental: 0,
                                                            }
                                                        }

                                                    } catch (error) {
                                                    }
                                                    
                                                    // Omitir modalidades com os valores zerados
                                                    {
                                                        let somaIs0Meta = Object.keys(valorMeta).reduce((acc, atual) => acc + valorMeta[atual], 0);
                                                        let somaIs0Realizado = Object.keys(valorRealizado).reduce((acc, atual) => acc + valorRealizado[atual], 0);
                                                        if(somaIs0Meta + somaIs0Realizado < 1) return;
                                                    }
                                                    // FIM - Omitir modalidades com os valores zerados

                                                    return (
                                                        <tr>
                                                            <td className="text-start" style={{ backgroundColor: "#c5c0ad" }}>{modalidade}</td>
                                                            <td>{utils.formataNumero(valorMeta["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorMeta["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorMeta["matricula_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorMeta["matricula_pago"] + valorMeta["matricula_nao_regimental"] + valorMeta["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorRealizado["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorRealizado["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorRealizado["matricula_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorRealizado["matricula_regimental"] + valorRealizado["matricula_nao_regimental"] + valorRealizado["matricula_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentual(valorMeta, valorRealizado, "matricula")}</td>
                                                            <td>{utils.formataNumero(valorMeta["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorMeta["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorMeta["hora_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorMeta["hora_pago"] + valorMeta["hora_nao_regimental"] + valorMeta["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorRealizado["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorRealizado["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(valorRealizado["hora_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#c5c0ad" }}>{utils.formataNumero(valorRealizado["hora_regimental"] + valorRealizado["hora_nao_regimental"] + valorRealizado["hora_pago"])}</td>
                                                            <td style={{ fontWeight: "600", backgroundColor: "#9d9475" }}>{utils.formataPercentual(valorMeta, valorRealizado, "hora")}</td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                                {
                                                    sigla !== "FACULDADE"
                                                    ?
                                                    <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad" }}>
                                                        <td>Total</td>
                                                        <td>{utils.formataNumero(total["matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_pago"])}</td>
                                                        <td>{utils.formataNumero(total["matricula_pago"] + total["matricula_nao_regimental"] + total["matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["r_matricula_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["r_matricula_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["r_matricula_pago"])}</td>
                                                        <td>{utils.formataNumero(total["r_matricula_regimental"] + total["r_matricula_nao_regimental"] + total["r_matricula_pago"])}</td>
                                                        <td>{utils.formataPercentualTotal(total, "matricula")}</td>
                                                        <td>{utils.formataNumero(total["hora_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["hora_pago"])}</td>
                                                        <td>{utils.formataNumero(total["hora_pago"] + total["hora_nao_regimental"] + total["hora_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["r_hora_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["r_hora_nao_regimental"])}</td>
                                                        <td>{utils.formataNumero(total["r_hora_pago"])}</td>
                                                        <td>{utils.formataNumero(total["r_hora_regimental"] + total["r_hora_nao_regimental"] + total["r_hora_pago"])}</td>
                                                        <td>{utils.formataPercentualTotal(total, "hora")}</td>
                                                    </tr>
                                                    :
                                                    <TabelaFaculdade {...this.state} verificaSePossuiRealizado={this.verificaSePossuiRealizado} />
                                                }
                                                {
                                                    sigla === "DR" 
                                                    ?
                                                    <Fragment>
                                                        <TabelaFaculdade {...this.state} verificaSePossuiRealizado={this.verificaSePossuiRealizado} />
                                                        <tr style={{ fontWeight: "700", backgroundColor: "#c5c0ad" }}>
                                                            <td>Total Geral</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["matricula_pago"] + totalGeral["matricula_nao_regimental"] + totalGeral["matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_matricula_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_matricula_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_matricula_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_matricula_regimental"] + totalGeral["r_matricula_nao_regimental"] + totalGeral["r_matricula_pago"])}</td>
                                                            <td>{utils.formataPercentualTotal(totalGeral, "matricula")}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["hora_pago"] + totalGeral["hora_nao_regimental"] + totalGeral["hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_hora_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_hora_nao_regimental"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_hora_pago"])}</td>
                                                            <td>{utils.formataNumero(totalGeral["r_hora_regimental"] + totalGeral["r_hora_nao_regimental"] + totalGeral["r_hora_pago"])}</td>
                                                            <td>{utils.formataPercentualTotal(totalGeral, "hora")}</td>
                                                        </tr>
                                                    </Fragment>
                                                    :
                                                    null
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </Fragment>

                            </Tab>
                        )
                    })}

                </Tabs>

            </Fragment>
        )
    }
}